import React from "react";
import {Tabs, Tab} from 'react-bootstrap';
import {connect} from 'react-redux';
import JoinCreateAccount from "./JoinCreateAccount";
import ContactDetailsForm from "../../components/common/ContactDetailsForm";
import LogInScreen from "../login/LogInScreen";
import SelectionTabs from "../../components/common/SelectionTabs";
import SelectionPane from "../../components/common/SelectionPane";
import {JoinCreateAccountConstants, URLs, FetchingTypes} from "../../common/constants";
import {setCreateAccountPage} from "../../actions/join/joinActions";
import {createFacebookMember, getSubscriptionStatus, resetEmailSent} from "../../actions/login/logInActions";
import {setMemberData} from "../../actions/login/memberDetailsActions";
import {isFetching} from "../../actions/common/fetchingActions";
import styles from "../../css/join/joinCreateAccount.less";
import {translate} from '../../i18n/translate.js';

const CREATE_ACCOUNT_TAB = "Create Account";
const LOGIN_TAB = "Login";

class JoinContactInfoStep extends React.Component {
    componentWillReceiveProps(nextProps) {
      if(nextProps.memberKey && nextProps.memberKey !== this.props.memberKey) {
          this.props.setCreateAccountPage(JoinCreateAccountConstants.CONTACT_DETAILS);
      }
    }

    componentWillMount() {
        if(this.props.memberKey) {
            this.props.setCreateAccountPage(JoinCreateAccountConstants.CONTACT_DETAILS);
        }
    }

    tabChange = (selectedTab) => {
        if(selectedTab === LOGIN_TAB) {
            this.props.resetEmailSent();
            this.props.setCreateAccountPage(JoinCreateAccountConstants.LOGIN);
        } else {
            this.props.setCreateAccountPage(JoinCreateAccountConstants.CREATE_CONTACT);
        }
    };

    joinCreateAccountView = () => {
      return(<JoinCreateAccount setCreateAccountPage={this.props.setCreateAccountPage}
                                facebookAppId={this.props.staticData.facebookAppId}
                                setMemberData={this.props.setMemberData}
                                createFacebookMember={this.props.createFacebookMember}
                                isGuestUser={this.props.isGuestUser}
                                getSubscriptionStatus={this.props.getSubscriptionStatus}
                                showLoading={this.props.showLoading}
                                flowType={URLs.JOIN}
                                clientViewPort={this.props.clientViewPort}
                                fbButtonEnabled={this.props.fbButtonEnabled}/>);
    };

    render() {
        const showLogin = !this.props.memberKey;
        if (!showLogin) {
            if (this.props.contactInfoPage === JoinCreateAccountConstants.CONTACT_DETAILS) {
                return (<div className="border-container create-account-tabs"><ContactDetailsForm flowType={URLs.JOIN}/></div>);
            } else {
                return (<div className="border-container create-account-tabs">
                    {this.joinCreateAccountView()}
                </div>);
            }
        }
        else if (this.props.clientViewPort.isXs) {
            return (<div className="join-contact-mobile">
                <Tabs className="join-mobile-tab" id="createAccountStep" defaultActiveKey={CREATE_ACCOUNT_TAB}
                      animation={false} onSelect={this.tabChange}>
                    <Tab title={translate(CREATE_ACCOUNT_TAB)} eventKey={CREATE_ACCOUNT_TAB}>
                        {
                            this.props.contactInfoPage === JoinCreateAccountConstants.CONTACT_DETAILS ?
                                <ContactDetailsForm flowType={URLs.JOIN}/> :
                                this.joinCreateAccountView()
                        }
                    </Tab>
                    <Tab title={translate(LOGIN_TAB)} eventKey={LOGIN_TAB}>
                        <LogInScreen flowType={URLs.JOIN}/>
                    </Tab>
                </Tabs>
            </div>);
        } else {
            return (<div className="border-container create-account-tabs">
                <SelectionTabs update={this.tabChange}>
                    <SelectionPane label={translate(CREATE_ACCOUNT_TAB)}>
                        {
                            this.props.contactInfoPage === JoinCreateAccountConstants.CONTACT_DETAILS ?
                                <ContactDetailsForm flowType={URLs.JOIN}/> :
                                this.joinCreateAccountView()
                        }
                    </SelectionPane>
                    <SelectionPane label={translate(LOGIN_TAB)}>
                        <LogInScreen flowType={URLs.JOIN}/>
                    </SelectionPane>
                </SelectionTabs>
            </div>);
        }
    }
}

const mapStateToProps = (state) => {
    const signupData = (state.signupData || {});
    return {
        clientViewPort: (state.clientViewPort || {}),
        memberKey: (state.memberDetails || {}).key,
        contactInfoPage: signupData.contactInfoPage,
        memberDetails: (state.memberDetails || {}),
        isGuestUser: signupData.isGuestUser,
        showLoading: isFetching(state, FetchingTypes.LOGIN),
        fbButtonEnabled: (state.loginStatus || {}).enableFBButton
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCreateAccountPage: (contactInfoPage) => {
            dispatch(setCreateAccountPage(contactInfoPage));
        },
        setMemberData: (member) => {
            dispatch(setMemberData(member))
        },
        createFacebookMember: (member) => {
            dispatch(createFacebookMember(member));
        },
        getSubscriptionStatus: (memberKey) => {
            dispatch(getSubscriptionStatus(memberKey))
        },
        resetEmailSent: ()=> {
            dispatch(resetEmailSent());
        }
    }
};
export default connect (mapStateToProps, mapDispatchToProps) (JoinContactInfoStep);


// WEBPACK FOOTER //
// ./src/containers/join/JoinContactInfoStep.js